import React, {useState} from 'react'
import {Header} from "../../../header/Header";
import {useSelector} from "react-redux";
import {Navigate, useParams, useNavigate, Link} from "react-router-dom";
import 'animate.css';
import {zynity_api, zynity_website} from "../../../../config/external-routes";
import { Button, Modal } from 'react-bootstrap';
import {MemberAccordion} from "./members/MemberAccordion";
import {MembersContainer} from "./members/MembersContainer";

export const TeamHeader = ({suffixRoute = ''}: any) => {
    const yii_url = zynity_website.yii_website_url;
    const {organization_id, team_id} = useParams();
    const [showMaintrax, setShowMaintrax] = useState(false);
    const user_organizations_obj = useSelector((state:any) => state.user_organizations);
    const user_organizations = user_organizations_obj.data?.data
    let organization = user_organizations.filter((item:any) => item.id == organization_id)[0];
    let organization_teams = organization.teams;
    let selected_team = organization_teams.filter((team:any) => team.id == team_id)[0];
    const navigate = useNavigate();
    const [showParticipantsModal, setShowParticipantsModal] = useState(false);

    const handleChangeOrganization = ({target}:any) => {
        let new_org_id = target.value;
        let organization = user_organizations.filter((item:any) => item.id == new_org_id)[0];

        let new_team_id = organization.teams[0].id;
        navigate(`/organizations/${new_org_id}/teams/${new_team_id}${suffixRoute}`)
    }

    const handleChangeOrgTeam = ({target}:any) => {
        let new_team_id = target.value;
        navigate(`/organizations/${organization_id}/teams/${new_team_id}${suffixRoute}`)
    }

    const toogleMaintrax = () => {
        if(showMaintrax === true) {
            setShowMaintrax(false);
        } else {
            setShowMaintrax(true);
        }
    }

    const openParticipantsModal = () => {
        setShowParticipantsModal(true)
    }

    const closeParticipantsModal = () => {
        setShowParticipantsModal(false)
    };

    const handleClickFacilitatorLink = (selectedTeamId: string) => {
        const form = document.getElementById(`facilitatorForm${selectedTeamId}`) as HTMLFormElement;
        if (form) {
            form.submit();
        }
    };

    return (
        <>
            <Header />
            <div className="row">
                <div className="col-12">
                    <nav className="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-center">
                        <ul className="navbar-nav d-flex align-items-center">
                            {
                                organization.image != null &&
                                <li className="nav-item mx-2 mt-2 mt-lg-0">
                                    <img style={{width: '120px', maxWidth: '120px', padding: 0}} src={zynity_api.download_file + organization.image} alt="Organization Image"/>
                                </li>
                            }
                            <li className="nav-item mx-2 mt-2 mt-lg-0">
                                <select className="form-select" aria-label="Default select example"
                                value={organization_id}
                                        onChange={handleChangeOrganization}
                                >
                                    {
                                        user_organizations.map((organization:any) => (
                                            <option key={organization.id} value={organization.id}>{organization.name}</option>
                                        ))
                                    }
                                </select>
                            </li>
                            <li className="nav-item mx-2 mt-2 mt-lg-0">
                                <select className="form-select" aria-label="Default select example"
                                        value={team_id}
                                        onChange={handleChangeOrgTeam}
                                >
                                    {
                                        organization_teams.map((team:any) => (
                                            <option key={team.id} value={team.id}>{team.TeamName}</option>
                                        ))
                                    }
                                </select>
                            </li>
                            <li className="nav-item mx-2 mt-2 mt-lg-0">
                                <button type="button" className="btn btn-teal btn-sm rounded-pill"
                                        onClick={openParticipantsModal}
                                >Participants <span
                                    className="badge bg-light text-dark">{selected_team.total_members}</span></button>

                                <Modal show={showParticipantsModal} onHide={closeParticipantsModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title className='text-muted fs-5'>Participants - Executive Team Team</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <MembersContainer closeModal={closeParticipantsModal} />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={closeParticipantsModal}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </li>
                            <li className="nav-item mx-2 mt-2 mt-lg-0">
                                <button type="button" className="btn btn-teal btn-sm rounded-pill" onClick={toogleMaintrax}>Main Trax</button>
                            </li>

                            {
                                selected_team.is_facilitator &&
                                <li className="nav-item mx-2 mt-2 mt-lg-0">
                                    <form id={`facilitatorForm${selected_team.id}`} className="d-none" method="post" action={`${yii_url}/userHome/index`}>
                                        <input type="hidden" name="teamId" value={selected_team.id}></input>
                                        <input type="hidden" name="orgId" value={organization_id}></input>
                                        <input type="hidden" name="teamMenuAction" value='FacilitatorDashboard'></input>
                                    </form>
                                    <img
                                        onClick={() => handleClickFacilitatorLink(selected_team.id)}
                                        data-toggle="tooltip"
                                        style={{width: '40px'}}
                                        className="team-icons clickable"
                                        src={require('../../../../assets/images/FacilitatorIcon.png')}
                                        alt="Facilitator Icon"
                                    />
                                </li>
                            }

                            {
                                selected_team.is_coach &&
                                <Link to="/coach">
                                    <img src={require('../../../../assets/images/coach_notes_icon.png')} width="40"></img>
                                </Link>
                            }

                        </ul>
                    </nav>
                </div>
                {
                    showMaintrax === true &&
                    <div className="col-12">
                        <nav className="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-center">
                            <ul className="navbar-nav d-flex align-items-center">
                                <div className='animate__animated animate__bounceIn' style={{padding: '0 15px', marginBottom: '10px', border: 'solid 1px #b7b7b7', boxShadow: '1px 2px #b7b7b7'}}
                                >Purpose: <span style={{color: 'teal'}}>{selected_team.Purpose}</span></div>
                            </ul>
                        </nav>
                    </div>
                }
            </div>
        </>
    )
}
